'use client'

import React, { useCallback } from 'react'
import { HamburgerMenuBroken } from 'solar-icons'
import { useSearchParams } from '@/lib/hooks'

import { Button } from '@/components/ui'

interface CategoryButtonProps extends React.ComponentPropsWithoutRef<'button'> {
  filterId: number
  title?: string
  isActive?: boolean
}

export const CategoryButton = React.memo(
  ({ title, filterId, isActive }: CategoryButtonProps) => {
    const { setSearchParams } = useSearchParams()

    const handleClick = useCallback(() => {
      setSearchParams({ productFilterId: filterId })
    }, [setSearchParams, filterId])

    return (
      <Button
        variant={isActive ? 'default' : 'outline'}
        className="gap-2 pl-3.5 pr-4"
        onClick={handleClick}
      >
        <div className="flex w-full items-center gap-2">
          <HamburgerMenuBroken className="size-4 shrink-0" strokeWidth={1.5} />
          <span className="font-medium">{title}</span>
        </div>
      </Button>
    )
  },
)

CategoryButton.displayName = 'CategoryButton'
